"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function makeItems({ value, results, resultIcon, noResultsMessage, }) {
    if (!results || !value) {
        return [];
    }
    if (results && results.length) {
        return results.map(result => (Object.assign({}, result, (resultIcon ? { icon: result.icon || resultIcon } : { icon: result.icon }))));
    }
    return [{ label: noResultsMessage } || { label: "" }];
}
exports.makeItems = makeItems;
//# sourceMappingURL=Autocomplete.utils.js.map